import { render } from "./CategoryAchievementRing.vue?vue&type=template&id=79756d5b&scoped=true"
import script from "./CategoryAchievementRing.vue?vue&type=script&lang=js"
export * from "./CategoryAchievementRing.vue?vue&type=script&lang=js"

import "./CategoryAchievementRing.vue?vue&type=style&index=0&id=79756d5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79756d5b"]])

export default __exports__